export const createBackdropSlice = set => ({
	isShownBackdrop: false,
	setIsShownBackdrop: value => set({ isShownBackdrop: value }),
	resetBackdropStore: () => set({ isShownBackdrop: false }),
});
